


<template lang="jade">

	div.dialogues
		dia(
			v-for="(dialogue, index) in dialogues"
			:key="dialogue.id"
			:dia="dialogue"
		)

</template>



<script>



	import dia from './app-dialogue.vue'



	const $cmp = {
		name : 'app-dialogues',
		components : {
			dia
		}
	}



	$cmp.computed = {}

	$cmp.computed.dialogues = function() {
		return this.$store.dialogues
	}



	export default $cmp



</script>



<style lang="stylus">

	.dialogues
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		overflow hidden
		z-index 9
		pointer-events none

</style>



// WEBPACK FOOTER //
// src/app-dialogues.vue